import React, {useState, useEffect} from 'react';
import { Stack, FormControl, OutlinedInput, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const SearchBar = ({ value, onChange, placeholder = 'Search', width = '25ch', delay = 500 }) => {

  const [searchTerm, setSearchTerm] = useState(value || '');

  useEffect(() => {
    const handler = setTimeout(() => {
      if (searchTerm !== value) {
        onChange({ target: { value: searchTerm } });
      }
    }, delay);

    return () => clearTimeout(handler);
  }, [searchTerm, delay]);
  
  return (
    <Stack direction="row" justifyContent="flex-end" alignItems="center" spacing={0}>
      <form noValidate autoComplete="off" className="formSearch">
        <FormControl sx={{ width }} size="small">
          <OutlinedInput
            placeholder={placeholder}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            endAdornment={
              <InputAdornment position="start">
                <SearchIcon />
              </InputAdornment>
            }
          />
        </FormControl>
      </form>
    </Stack>
  );
};

export default SearchBar;
